module.exports = __webpack_public_path__ + "img/experience.e106fd0c.svg";